import gql from 'graphql-tag';
import { scheduledSessionParticipantEntryFieldsFragment } from '../fragments';

export const unlockWaitingParticipantsMutation = gql`
  mutation UnlockWaitingParticipants($scheduledSessionId: ID!, $participants: [ID!]!) {
    unlockWaitingParticipants(scheduledSessionId: $scheduledSessionId, participants: $participants) {
      ...AdminScheduledSessionParticipantEntryFields
    }
  }

  ${scheduledSessionParticipantEntryFieldsFragment}
`;